import axios from 'axios'

export default function Creater(condition, callback) {
        
    axios.post(condition.url, condition.data)
    
    .then(res => {

        callback({
            data : res.data.info || null,
            message : res.data.message
        })

    })

    .catch(err => {

        callback({
            data : null,
            message : 'ERROR'
        })

    })
    
}


// WEBPACK FOOTER //
// ./src/controller/Creater.js